module.exports = __webpack_public_path__ + "static/media/preventivo_rojo.348cd9a8.svg";